import tr from './assets/i18n/tr.json'
import en from './assets/i18n/en.json'

import VueI18n from 'vue-i18n'
import Vue from 'vue'

Vue.use(VueI18n);

var getFirstBrowserLanguage = function () {
    var nav = window.navigator,
    browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
    i,
    language;
  
    // support for HTML 5.1 "navigator.languages"
    if (Array.isArray(nav.languages)) {
      for (i = 0; i < nav.languages.length; i++) {
        language = nav.languages[i];
        if (language && language.length) {
          return language;
        }
      }
    }
  
    // support for other well known properties in browsers
    for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
      language = nav[browserLanguagePropertyKeys[i]];
      if (language && language.length) {
        return language;
      }
    }
  
    return null;
};
var navlang=getFirstBrowserLanguage().substring(0, 2);

//let navlang = navigator.language;

export default new VueI18n ({
    locale : localStorage.getItem('lang') || navlang,
    messages:{
        tr:tr,
        en:en
    }
})


// WEBPACK FOOTER //
// ./src/i18n.js